<template>
	<div class="shop-product-check">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Brand Price Adjustments</h1>

		<div class="content-wrapper">
			<div class="button-container" @click="addNew()">
				<div class="big-button">
					Add New
				</div>
			</div>
		</div>

		<div class="brand-filter-wrapper">
			<b-field>
				<div class="filter-label">Brand Filter</div>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="code"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>

				<div class="small-button filter-button" @click="getData()">
					Filter
				</div>

				<div class="small-button filter-button" @click="getData(true)">
					Clear
				</div>
			</b-field>
		</div>

		<div class="price-adjustment-table heartbeat-warpper header">
			<div>Name</div>
			<div>Brand</div>
			<div>Shops</div>
			<div>Type</div>
			<div>Values</div>
			<div>Status</div>
			<div>Edit</div>
		</div>

		<div v-if="adjustments.length > 0">
			<div v-for="(adjustment, index) of adjustments" :key="index" class="price-adjustment-table">
				<div class="header" @click="goTo(adjustment._id)">
					<a>{{ adjustment.name }}</a>
				</div>
				<div>{{ adjustment.brand.name }} ( {{ adjustment.brand.code }})</div>
				<div>{{ adjustment.shopNames }}</div>
				<div>{{ adjustment.type }}</div>
				<div>{{ adjustment.value }}</div>
				<div>{{ statusText(adjustment.status) }}</div>
				<div class="header" @click="goTo(adjustment._id)"><a>Edit</a></div>
			</div>
		</div>

		<div class="pager">
			<paginate
				v-model="page"
				:page-count="pageCount"
				:click-handler="pagerClick"
				:prev-text="'prev'"
				:next-text="'next'"
				:container-class="'pagination'"
			>
			</paginate>
		</div>
	</div>
</template>

<script>
export default {
	title: 'Brand Price Adjustments',
	name: 'brand-price-adjustments',
	data: () => ({
		limit: 20,
		isLoading: false,
		adjustments: [],
		pageCount: 0,
		page: 1,

		brands: [], // To store brands
		selectedBrand: '',
		brandSuggestions: ''
	}),

	mounted: async function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		await this.getData()

		await this.getBrands()
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.code
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		pagerClick: async function(pageNumber) {
			// Calculate how many items to skip
			var skip

			if (pageNumber == 1) {
				skip = 0
			} else {
				skip = (pageNumber - 1) * this.limit
			}

			var data = { sort: { createdAt: 'desc' }, populate: ['brand', 'shops'], skip, limit: this.limit }

			// add brand filter
			if (this.selectedBrand) {
				data.brand = this.selectedBrand._id
			}

			const apiGetAdjustment = await this.$api.brandAdjustPriceList({
				data
			})

			// Extract shop names and join them with commas
			apiGetAdjustment.data.list.forEach(item => {
				// Extract shop names and join them with commas
				item.shopNames = item.shops.map(shop => shop.name).join(', ')
			})

			this.adjustments = apiGetAdjustment.data.list
		},

		// Verify if the brand ID and values are valid
		heartbeat: async function() {
			return
		},

		addNew: function() {
			this.$router.push({ name: 'addBrandPriceAdjustment' })
		},

		// brandFilter: async function() {
		// 	if (this.selectedBrand) {
		// 		console.log(this.selectedBrand)
		// 	}
		// },

		goTo: function(id) {
			if (id) {
				this.$router.push({ name: 'editBrandPriceAdjustment', params: { id } })
			}
		},

		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},

		convertTime: function(time) {
			return this.$moment(time).fromNow()
		},

		statusText: function(status) {
			if (status) {
				return 'Enabled'
			} else {
				return 'Disabled'
			}
		},

		// Get list of data
		getData: async function(clear = false) {
			var data = { sort: { createdAt: 'desc' }, populate: ['brand', 'shops'], limit: this.limit }

			if (clear == true) {
				this.selectedBrand = ''
				this.brandSuggestions = ''
			}

			// add brand filter
			if (this.selectedBrand) {
				data.brand = this.selectedBrand._id
			}

			const apiGetAdjustment = await this.$api.brandAdjustPriceList({
				data
			})

			// Extract shop names and join them with commas
			apiGetAdjustment.data.list.forEach(item => {
				// Extract shop names and join them with commas
				item.shopNames = item.shops.map(shop => shop.name).join(', ')
			})

			this.adjustments = apiGetAdjustment.data.list

			this.pageCount = apiGetAdjustment.data.total / this.limit
			this.pageCount = Math.ceil(this.pageCount)

			// this.shops = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';

.pagination {
	margin: auto;
}

.filter-button {
	margin: 0 0 0 10px;
}

.filter-label {
	padding-top: 10px;
	margin-right: 10px;
}

.brand-filter-wrapper {
	margin: 20px auto;
	width: 500px;
}
</style>
